import {
  useGetABOProfileQuery,
  useGetAboLineageQuery,
  useGetProfileNotesQuery,
} from "../../../../services/AboProfile/AboProfileAPI";
import { isRootLineage } from "../../../../common/components/DownlineProfileLOS/DownlineProfileIcon";
import { useAppSelector } from "../../../../store";

const useProfileBannerData = () => {
  const selectedAffAbo = useAppSelector((s) => s.downlineProfile.affAbo);
  const [aff = "", abo = ""] = selectedAffAbo.split("-");
  const isFromEdLos = useAppSelector((s) => s.profile.isFromEdLos);
  const edlosAboMeta = useAppSelector((s) => s.profile.edlosAboMeta);
  const edlosRootAffAbo = useAppSelector((s) => s.profile.edlosRootAffAbo);
  const edlosRootDepth = useAppSelector((s) => s.profile.edlosRootDepth);
  const showAutoRenewal = useAppSelector(
    (s) => s.boot.configuration.profile?.additionalRegInfo?.showAutoRenewal ?? true,
  );
  const { data, isFetching, isError, refetch } = useGetABOProfileQuery(
    { aff, abo, ...(isFromEdLos ? { includePlatinumAndAbove: true } : {}) },
    { skip: !aff || !abo },
  );
  const { data: notesData } = useGetProfileNotesQuery({ affabo: `${aff}-${abo}` }, { skip: !aff || !abo });
  const { data: lineageData } = useGetAboLineageQuery(
    {
      aff,
      abo,
      IsEdlos: isFromEdLos,
      ...(isFromEdLos && edlosRootAffAbo ? { EdlosRootAffAbo: edlosRootAffAbo } : {}),
      ...(isFromEdLos && edlosRootDepth !== null ? { EdlosRootDepth: edlosRootDepth } : {}),
    },
    { skip: !aff || !abo },
  );
  return {
    aff,
    abo,
    data,
    isFetching,
    isError,
    refetch,
    isFromEdLos,
    edlosAboMeta,
    isRootAbo: isRootLineage(lineageData?.lineage),
    tags: {
      isOnAutoRenewal: showAutoRenewal && data?.additionalRegInfo?.autoRenewal,
      isOnSop: false,
      hasNotes: (notesData?.notes?.length ?? 0) > 0,
    },
  };
};

export default useProfileBannerData;
